export function isLayout(x, throwError) {
  if (typeof x !== 'object' || !x) return false;
  const response = throwError ? err => {
    throw new Error(err);
  } : () => false;
  if (typeof x.type !== 'string') return response('需要type');
  if (x.props && typeof x.props !== 'object') return response('需要props');
  if (x.slots && !Object.values(x.slots).every(isLayoutArray)) return response('需要slots');
  if (x.children && !isLayoutArray(x.children)) return response('需要children');
  return true;
}
export function isLayoutArray(x) {
  if (!Array.isArray(x)) return false;
  return x.every(it => isLayout(it));
}
//# sourceMappingURL=isLayout.js.map
